import { call, put, takeLatest } from "@redux-saga/core/effects";
import { jarvisPrimeRmsConstants} from "./jarvisPrimeRmsConstants";

import { tracker } from "library/tracker";
import { jarvisPrimeRmsApis } from "./jarvisPrimeRmsApis";
import { jarvisPrimeRmsParsers } from "./jarvisPrimeRmsParsers";


function* jarvisPrimeRmsSaga() {
    try {
        yield put({ type: jarvisPrimeRmsConstants.PRIME_RMS_REQUEST });
        const resData = yield call(jarvisPrimeRmsApis.getRMSDetails);
        const ParsedData = jarvisPrimeRmsParsers.rmsDetails(resData);
        yield put({ type: jarvisPrimeRmsConstants.PRIME_RMS_RESPONSE, payload: ParsedData });
        //NOTE event_tracker => actionCenterInvestMore
        tracker.actionCenterInvestMore.portfolioGenerationSuccess();
    } catch (e) {
        yield put({ type: jarvisPrimeRmsConstants.PRIME_RMS_RESPONSE, payload: [] });
        //NOTE event_tracker => actionCenterInvestMore
        tracker.actionCenterInvestMore.portfolioGenerationFailed({ error_msg: e.message });
    }
}

export function* registerjarvisPrimeRMSSaga() {
    yield takeLatest(jarvisPrimeRmsConstants.PRIME_RMS_SAGA, jarvisPrimeRmsSaga);
}

